// Import React and ReactDOM
import React from 'react';
import ReactDOM from 'react-dom';
// Import the App component
import App from './App';

// Use ReactDOM to render the App component into the div with the id of 'root' in your index.html
ReactDOM.render(<App />, document.getElementById('root'));
